import { render, staticRenderFns } from "./KBDailyContactList.vue?vue&type=template&id=777090e0&"
import script from "./KBDailyContactList.vue?vue&type=script&lang=ts&"
export * from "./KBDailyContactList.vue?vue&type=script&lang=ts&"
import style0 from "./KBDailyContactList.vue?vue&type=style&index=0&id=777090e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCheckbox})
